import * as Sentry from "@sentry/browser";

import { SENTRY_DSN } from "./config.js";
import "../css/normalize.css";
import "../css/vendor-webflow.css";
import "../css/yenda.css";
import "../css/website.css";
import HamburgerView from "./views/hamburgerView";

/* eslint-disable */
Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    // Send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
});
/* eslint-enable */

// Create instance
const hamburgerView = new HamburgerView();

// Call method on the instance
hamburgerView.toggleMenu();
